import React from 'react';

import { OnClick } from '@rbi-ctg/frontend';
import { CustomEventNames } from 'state/mParticle';

import {
  CateringDeliveryPrompt,
  CateringPickUpPrompt,
  DeliveryPrompt,
  PickUpPrompt,
} from './prompts';
import WrapperButton from './wrapper-button';

interface IServiceModeButton {
  selectServiceMode: OnClick;
  enableButton?: boolean;
  offerUnavailableForDelivery?: boolean;
  offerUnavailableForPickup?: boolean;
}

export const DeliveryButton: React.FC<IServiceModeButton> = ({
  selectServiceMode,
  enableButton = false,
  offerUnavailableForDelivery,
}) => {
  return (
    <WrapperButton
      disabled={!enableButton}
      data-testid="service-mode-delivery"
      onClick={selectServiceMode}
      className="deliveryButton"
      eventName={CustomEventNames.BUTTON_CLICK_DELIVERY}
    >
      <DeliveryPrompt
        enabled={enableButton}
        offerUnavailableForDelivery={offerUnavailableForDelivery}
        aria-hidden
      />
    </WrapperButton>
  );
};

export const PickupButton: React.FC<IServiceModeButton> = ({
  selectServiceMode,
  offerUnavailableForPickup,
  enableButton = false,
}) => (
  <WrapperButton
    disabled={!enableButton}
    eventName={CustomEventNames.BUTTON_CLICK_PICKUP}
    data-testid="service-mode-pickup"
    onClick={selectServiceMode}
    className="pickupButton"
  >
    <PickUpPrompt
      enabled={enableButton}
      aria-hidden
      offerUnavailableForPickup={offerUnavailableForPickup}
    />
  </WrapperButton>
);

export const CateringPickupButton: React.FC<IServiceModeButton> = ({ selectServiceMode }) => {
  return (
    <WrapperButton
      eventName={CustomEventNames.BUTTON_CLICK_CATERING_PICKUP}
      data-testid="service-mode-catering-pickup"
      onClick={selectServiceMode}
      className="cateringPickupButton"
    >
      <CateringPickUpPrompt enabled aria-hidden />
    </WrapperButton>
  );
};

export const CateringDeliveryButton: React.FC<IServiceModeButton> = ({
  selectServiceMode,
  enableButton = false,
}) => {
  return (
    <WrapperButton
      disabled={!enableButton}
      eventName={CustomEventNames.BUTTON_CLICK_CATERING_DELIVERY}
      data-testid="service-mode-catering-delivery"
      onClick={selectServiceMode}
      className="cateringDeliveryButton"
    >
      <CateringDeliveryPrompt enabled={enableButton} aria-hidden />
    </WrapperButton>
  );
};
